<script setup></script>

<template>
  <div class="mx-auto flex flex-col justify-center gap-12 lg:flex-row">
    <div class="flex-none bg-green-700 p-4">
      <div class="flex justify-center">
        <NuxtImg
          src="/home/kate-and-redhead-2.jpg"
          class=""
          format="webp"
          alt="A red panda bust on the left and Kate on the right."
          width="428"
          height="500"
        />
      </div>
      <div class="font-script pt-6 text-center text-4xl text-white">KATE! & Redhead 2</div>
      <div class="font-script pt-2 pb-6 text-center text-sm text-white">(In the studio)</div>
    </div>
    <div>
      <h1 class="border-b-cerulean-700 border-b-4 text-4xl text-balance">Kate is an Artist / Instructor in Atlanta</h1>
      <div class="space-y-8 pt-12 text-3xl">
        <NuxtLink to="/art" class="block bg-green-200 p-3 pt-4 hover:bg-green-300">Browse the Art </NuxtLink>
        <a
          target="_blank"
          class="bg-ice-200 hover:bg-ice-300 block p-3 pt-4"
          href="https://www.itstheartcenter.org/service-page/h-spr-kate-n-wed-pm-clay-sculpture?referral=service_list_widget"
        >
          Take a Class with Kate
        </a>
        <a target="_blank" class="block bg-red-100 p-3 pt-4 hover:bg-red-200" href="https://www.twitch.tv/kratykat">
          Watch on Twitch
        </a>
        <a
          target="_blank"
          class="block bg-yellow-500 p-3 pt-4 hover:bg-yellow-600"
          href="https://buymeacoffee.com/kraty"
        >
          Support the Artist
        </a>
      </div>
    </div>
  </div>
</template>
